export const ERROR_MESSAGES = {
  UNEXPECTED: "Ha ocurrido un error inesperado.",
  SESSION_EXPIRED: "Ha expirado la sesión de usuario, ingrese nuevamente.",
  INVALID_USER_CREDENTIALS: "Credenciales de usuario son invalidas.",
};
